import script from "./SocialsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialsBlock.vue?vue&type=script&setup=true&lang=js"

import "./SocialsBlock.vue?vue&type=style&index=0&id=6db95930&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db95930"]])

export default __exports__